import routeShellConfig from "../../config/route-shell.json";

const marketingExactRoutes = new Set(routeShellConfig.marketingExactRoutes || []);
const marketingPrefixes = routeShellConfig.marketingPrefixes || [];

export function normalizeRouteShellPath(pathname = "/") {
  return String(pathname || "/").replace(/\/+$/, "") || "/";
}

export function isMarketingRoute(pathname = "/") {
  const normalizedPathname = normalizeRouteShellPath(pathname);
  if (marketingExactRoutes.has(normalizedPathname)) return true;
  return marketingPrefixes.some(
    (prefix) => normalizedPathname === prefix || normalizedPathname.startsWith(`${prefix}/`)
  );
}

export function getRouteShell(pathname = "/") {
  return isMarketingRoute(pathname) ? "marketing" : "app";
}

export { marketingExactRoutes, marketingPrefixes };
